/**
 * Custom set of severity levels that fits our implementation. Based on PINOs underlying logic
 *
 * See more at https://github.com/pinojs/pino/blob/master/docs/api.md#loggerlevel-string-gettersetter
 */
export let SeverityLevels = /*#__PURE__*/function (SeverityLevels) {
  SeverityLevels[SeverityLevels["DEBUG"] = 5] = "DEBUG";
  SeverityLevels[SeverityLevels["INFO"] = 10] = "INFO";
  SeverityLevels[SeverityLevels["METRIC"] = 15] = "METRIC";
  SeverityLevels[SeverityLevels["WARN"] = 40] = "WARN";
  SeverityLevels[SeverityLevels["ERROR"] = 50] = "ERROR";
  return SeverityLevels;
}({});
//# sourceMappingURL=SeverityLevels.js.map